// extracted by mini-css-extract-plugin
module.exports = {"card":"UwyesOxotcfSO1Rv2e9O","downloadButton":"PunPdHhk2AcJujaRSfJz","fieldset":"Cg4QonFdixWB3Njnq6Hf"};